<template>
	<section class="business-growths">
		<h1>赋能工程企业自上而下私域精准精细化业务管理</h1>
		<div class="business-growth-box">
			<div class="business-growth-group left">
				<div
					class="item"
					v-for="item in firstRowList"
					:key="item.id"
				>
					<el-row
						:class="{
							'padding-right': item.direction === 'left',
							'padding-left': item.direction === 'right'
						}"
					>
						<el-col
							:span="18"
							class="text-right"
							><h6>{{ item.title }}</h6>
							<p>{{ item.text }}</p></el-col
						>
						<el-col
							:span="6"
							class="right"
							><div class="circle">
								<img
									:src="item.icon"
									class="icon"
								/></div
						></el-col>
					</el-row>
				</div>
			</div>
			<div class="business-growth-group right">
				<div
					class="item"
					v-for="item in secondRowList"
					:key="item.id"
				>
					<el-row
						:class="{
							'padding-right': item.direction === 'left',
							'padding-left': item.direction === 'right'
						}"
					>
						<el-col
							:span="6"
							class="left"
							><div class="circle">
								<img
									:src="item.icon"
									class="icon"
								/></div
						></el-col>
						<el-col
							:span="18"
							class="text-left"
							><h6>{{ item.title }}</h6>
							<p>{{ item.text }}</p></el-col
						>
					</el-row>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'BusinessGrowth',
	components: {},
	data() {
		return {
			firstRowList: [
				{
					id: 0,
					title: '跨组织业务多方协同',
					text: '针对集团-公司-项目部相互独立的应用场景，利用子流程与数据权限控制助力企业连接上下游',
					icon: 'https://static.bimcc.com/openim/Frame%20%2811%2968C02777D6DCCB74C85DDEAD6261AB0E.png',
					direction: 'right'
				},
				{
					id: 1,
					title: '元数据业务流程建模',
					text: '拖拉拽实现复杂业务逻辑的编排，看得见的元数据构成以及数据流向，业务建模方式实现无代码应用构建',
					icon: 'https://static.bimcc.com/openim/Frame%20%2812%29B48D2F8C8E9811EEC06076C6501CBAD5.png',
					direction: 'left'
				},
				{
					id: 2,
					title: '拖拉拽审批流程设计',
					text: '丰富的流程配置参数打造中国特色审批流，覆盖大多数大型企事业单位的业务流程场景需求',
					icon: 'https://static.bimcc.com/openim/Frame%20%2813%29CDA5395883DC5D8DBB25DFA218C2130E.png',
					direction: 'right'
				}
			],
			secondRowList: [
				{
					id: 0,
					title: '多维数据图形化分析',
					text: '全链路触点数据捕捉，通过图形化交互建模配置实现多维度数据分析，帮助企业高效运营决策',
					icon: 'https://static.bimcc.com/openim/Frame%20%2814%297DCDB13CC23A8449D1C0EDC542E98B7E.png',
					direction: 'left'
				},
				{
					id: 1,
					title: '所见即所得表单设计',
					text: '图形化表单设计，一次设计多端适配，数十种基础控件，多种工程专业控件，可视化设计，拖拽式搭建',
					icon: 'https://static.bimcc.com/openim/Frame%20%2815%297D5F401F9170370703EECCF6601234D9.png',
					direction: 'right'
				},
				{
					id: 2,
					title: '视图设计可视化配置',
					text: '助企业面向不同场景、不同角色快速灵活配置视图，图形化方式跨表组合您想要的数据视图',
					icon: 'https://static.bimcc.com/openim/Frame%20%2817%29B88AE5D6BCE4837CE57A8AE09CF2DDCC.png',
					direction: 'left'
				}
			]
		};
	},
	methods: {}
};
</script>

<style lang="less" scoped>
.padding-right {
	padding-right: 55px;
	box-sizing: border-box;
}
.padding-left {
	padding-left: 55px;
	box-sizing: border-box;
}
.circle {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 62px;
	height: 62px;
	background: #eeeeee;
	border-radius: 50%;
}
.text-left {
	text-align: left;
}
.text-right {
	text-align: right;
}
.left {
	display: flex;
	justify-content: flex-start;
}
.right {
	display: flex;
	justify-content: flex-end;
}
.business-growths {
	position: relative;
	width: 100%;
	height: 100%;
	text-align: left;
	h1 {
		padding: 91px 0 80px 0;
		box-sizing: border-box;
		color: #131314;
		font-family: 'Source Han Sans CN';
		font-style: normal;
		font-weight: 700;
		font-size: 42px;
		line-height: 63px;
		text-align: center;
		white-space: nowrap;
		-webkit-animation-duration: 1s;
		animation-duration: 1s;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
		webkit-animation-name: h1;
		animation-name: h1;
	}
	@keyframes h1 {
		0% {
			opacity: 0;
			transform: translate(0px, 100px) scale3d(0.8, 0.8, 1);
		}
		100% {
			opacity: 1;
			transform: translate(0px, 0px);
		}
	}
	.business-growth-box {
		display: flex;
		justify-content: space-between;
		width: 100%;
		height: 455px;
		.business-growth-group {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 39%;
			height: 100%;
			.el-row {
				display: flex;
				align-items: center;
			}
			.item {
				display: flex;
				align-items: center;
				width: 100%;
				h6 {
					padding-bottom: 10px;
					box-sizing: border-box;
					color: #303030;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 500;
					font-size: 24px;
					line-height: 36px;
					white-space: nowrap;
				}
				p {
					color: #8a8a8a;
					font-family: 'Source Han Sans CN';
					font-style: normal;
					font-weight: 400;
					font-size: 16px;
					line-height: 24px;
				}
			}
		}
	}
}
</style>
